import blog1 from  '../img/blogs/blog1.svg';
import blog3 from  '../img/blogs/blog3.svg';
import blog2 from  '../img/blogs/blog2.svg';
import blog4 from  '../img/blogs/blog4.svg';

const blogs = [
    {
        id: 1,
        title: 'How To Work from Home',
        date: '01',
        month: 'April',
        image: blog1
    },
    {
        id: 2,
        title: 'How To Use SEO Efficiently',
        date: '01',
        month: 'April',
        image: blog2
    },
    {
        id: 3,
        title: 'How to choose a programming Language',
        date: '01',
        month: 'April',
        image: blog3,
        link: 'https://www.google.co.uk/'
    },
    {
        id: 4,
        title: 'How To Tse SEO Efficiently',
        date: '01',
        month: 'April',
        image: blog4
    },
    {
        id: 5,
        title: 'How To Tse SEO Efficiently',
        date: '01',
        month: 'April',
        image: blog4
    }
]

export default blogs;